import { OptJobType } from 'api/optJobs/optJobs.api'

export type CollectedSettingsFilterConfig = {
  allowedOptJobTypes: OptJobType[]
  subtypeExpandedOptJobTypes: OptJobType[]
}

export const COLLECTED_SETTINGS_FILTER_CONFIG: CollectedSettingsFilterConfig = {
  allowedOptJobTypes: ['regular', 'followup_with_deviations', 'followup_without_deviations', 'settlement'],
  subtypeExpandedOptJobTypes: ['settlement'],
}
